import { ColumnMetadata, ColumnTypes, RowSizes } from "~/components/DataGrid";
import { Asset, AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkSquare } from "@fortawesome/pro-regular-svg-icons";
import { cn } from "~/lib/utils";
import { Anchor } from "~/components/Anchor";
import { AssetTableRowData } from "../types";
import { Tooltip } from "~/components/Tooltip";

// // // //

export const DOCUMENTS_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> =
    {
        label: "Terms",
        slug: "Terms",
        type: ColumnTypes.string,
        width: 550,
        loginRequired: true,
        render: (item, { size }) => {
            if (item.isAsset) {
                const asset = item as Asset;

                if (
                    !asset.legal_structure__document_name ||
                    !asset.legal_structure__document_url
                ) {
                    return <Emdash />;
                }

                return (
                    <Tooltip
                        placement="top-start"
                        tooltipContent={
                            <div className="w-max px-3">
                                <p className="py-1.5 text-xs text-center">
                                    {
                                        asset.legal_structure__document_description
                                    }
                                </p>
                            </div>
                        }
                    >
                        {({ setTriggerRef }) => (
                            <Anchor
                                openInNewTab
                                setTriggerRef={setTriggerRef}
                                href={asset.legal_structure__document_url!}
                                analyticsLabel="Asset Table - Document Link"
                                variant="default"
                                className="flex items-center"
                            >
                                <div className="dg-overflow">
                                    {asset.legal_structure__document_name}
                                </div>
                                <FontAwesomeIcon
                                    icon={faExternalLinkSquare}
                                    className={cn("ml-2", {
                                        "h-3": size === RowSizes.extraSmall,
                                        "h-4": size === RowSizes.small,
                                        "h-5": size === RowSizes.medium,
                                        "h-6": size === RowSizes.large,
                                        "h-7": size === RowSizes.extraLarge,
                                    })}
                                />
                            </Anchor>
                        )}
                    </Tooltip>
                );
            }

            return <Emdash />;
        },
    };
